export const myWinesFiltersName = {
  offerTypeFilter: 'offerTypeFilter',
  usersFilter: 'usersFilter',
  countryFilter: 'countryFilter',
  creationDateFilter: 'creationDateFilter',
  lastUpdateFilter: 'lastUpdateFilter',
  brandFilter: 'brandFilter',
  nationalGITypeFilter: 'nationalGITypeFilter',
  wineRegionEUFilter: 'wineRegionEUFilter',
  geoIndicationFilter: 'geoIndicationFilter',
  specialClassificationFilter: 'specialClassificationFilter',
  wineTypeFilter: 'wineTypeFilter',
  wineColourFilter: 'wineColourFilter',
  sweetnessTypeFilter: 'sweetnessTypeFilter',
  vintageFilter: 'vintageFilter',
  bottleSizeFilter: 'bottleSizeFilter',
  packageTypeFilter: 'packageTypeFilter',
  grapesFilter: 'grapesFilter',
  monocepageFilter: 'monocepageFilter',
  certificationFilter: 'certificationFilter',
  wwlRatingFilter: 'wwlRatingFilter',
  rrpFilter: 'rrpFilter',
  reviewsFilter: 'reviewsFilter',
  invalidRecordFilter: 'invalidRecordFilter',
  showLatestVintagesFilter: 'showLatestVintagesFilter',
  alcoholLevelFilter: 'alcoholLevelFilter',
}

export const myWinesFiltersTitle = {
  offerTypeFilter: 'filters.names.offers',
  usersFilter: 'filters.names.users',
  countryFilter: 'filters.names.country',
  creationDateFilter: 'filters.names.creationDate',
  lastUpdateFilter: 'filters.names.lastUpdate',
  brandFilter: 'filters.names.brandFilter',
  nationalGITypeFilter: 'filters.names.nationalGITypeFilter',
  wineRegionEUFilter: 'filters.names.wineRegionEUFilter',
  geoIndicationFilter: 'filters.names.geoIndicationFilter',
  specialClassificationFilter: 'filters.names.specialClassificationFilter',
  wineTypeFilter: 'filters.names.wineTypeFilter',
  wineColourFilter: 'filters.names.wineColourFilter',
  sweetnessTypeFilter: 'filters.names.sweetnessTypeFilter',
  vintageFilter: 'filters.names.vintageFilter',
  bottleSizeFilter: 'filters.names.bottleSizeFilter',
  packageTypeFilter: 'filters.names.packageTypeFilter',
  grapesFilter: 'filters.names.grapesFilter',
  monocepageFilter: 'filters.names.monocepageFilter',
  certificationFilter: 'filters.names.certificatesFilter',
  wwlRatingFilter: 'filters.names.wwlRatingFilter',
  rrpFilter: 'filters.names.rrp',
  reviewsFilter: 'filters.names.havePublicReviewsFilters',
  invalidRecordFilter: 'filters.names.invalidRecord',
  showLatestVintagesFilter: 'filters.names.showLatestVintages',
  alcoholLevelFilter: 'filters.names.alcoholLevelFilter',
}

export const myWinesFiltersKey = {
  offerTypeFilter: 'sellerHasOffer',
  usersFilter: 'contributorUsername',
  countryFilter: 'wine.country',
  creationDateFilter: 'createdAt',
  lastUpdateFilter: 'updatedAt',
  brandFilter: 'wine.brand',
  nationalGITypeFilter: 'wine.nationalGIType',
  showLatestVintagesFilter: 'onlyLatestVintage',
  alcoholLevelFilter: 'alcoholOnLabel',
  wineRegionEUFilter: 'wine.wineRegionEU',
  geoIndicationFilter: 'wine.geoIndication',
  specialClassificationFilter: 'wine.specialClassification',
  wineTypeFilter: 'wine.wineType',
  wineColourFilter: 'wine.wineColor',
  sweetnessTypeFilter: 'wine.sweetnessLevel',
  vintageFilter: 'wine.vintage',
  bottleSizeFilter: 'bottleSize',
  packageTypeFilter: 'packageType',
  grapesFilter: 'grapeAndMonocepage',
  monocepageFilter: 'wine.monocepage',
  certificationFilter: 'wine.certification',
  wwlRatingFilter: 'wine.rating',
  rrpFilter: 'priceAtWinery',
  reviewsFilter: 'havePublicPublishedReviews',
  invalidRecordFilter: 'invalidRecord',
}
